import { FC } from 'react';
import { useFragment } from 'react-relay';
import graphql from 'babel-plugin-relay/macro';

import Section from 'components/Section';

import { OrderEditMainServices_order$key } from '__generated__/OrderEditMainServices_order.graphql';
import ServicesTable from 'components/ServicesTable';
import { Alert } from '@mui/material';

type Props = {
  order: OrderEditMainServices_order$key;
};

const OrderEditMainServices: FC<Props> = ({ order }) => {
  const { items } = useFragment(
    graphql`
      fragment OrderEditMainServices_order on Order {
        items {
          isService
          ...ServicesTable_items
        }
      }
    `,
    order
  );

  const services = items.filter(({ isService }) => isService);

  return (
    <Section id="services" title="Paslaugos">
      {services.length > 0 ? (
        <ServicesTable items={services} />
      ) : (
        <Alert severity="info">Jokių paslaugų neužsakyta</Alert>
      )}
    </Section>
  );
};

export default OrderEditMainServices;
